function initThumbnailSlider() {
  const $slider = $('.thumnbnail-media-position-verticle .thumbnail-list');
  const totalSlides = $slider.children().length;

  // Check for desktop screen size and enough slides
  if (window.innerWidth >= 768 && totalSlides > 4) {
    if (!$slider.hasClass('slick-initialized')) {
      $slider.slick({
        infinite: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        vertical: true,
        verticalSwiping: true,
        arrows: true,
        draggable: true, // Ensure that dragging is enabled
        prevArrow: '<div class="slick-prev"><svg class="icon--icon-prev" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path fill="currentColor" d="M7 1L5.6 2.5L13 10l-7.4 7.5L7 19l9-9z"/></svg></div>',
        nextArrow: '<div class="slick-next"><svg class="icon--icon-next" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path fill="currentColor" d="m4 10l9 9l1.4-1.5L7 10l7.4-7.5L13 1z"/></svg></div>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3, // Adjust number of slides based on screen size
            }
          }
        ]
      });

      // Force the slider to recalculate width and height after initialization
  
    $slider.slick("setPosition");
 

    
    
    }
  } else {
    // Unslick if slider is already initialized
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
  }
}

// Call the function
initThumbnailSlider();

// Optional: re-init if needed in Shopify customizer or dynamically loaded content
if (Shopify.designMode) {
  $(document).on('shopify:section:load shopify:section:select shopify:block:select', function () {
    initThumbnailSlider();
  });
}

document.addEventListener('shopify:section:load', () => {
  initThumbnailSlider();
});
document.addEventListener('shopify:section:select', () => {
  initThumbnailSlider();
});

document.addEventListener('shopify:section:deselect', () => {
  initThumbnailSlider();
});
